import CommonUI from "./CommonUI";
export default CommonUI;